import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ConsumablesFormStepSection } from "@jti/ui/components/ConsumablesFormStepSection";
import { QuantityRadioGroup } from "@jti/ui/components/QuantityRadioGroup";
import { QuantityGroupTitle } from "./components/QuantityGroupTitle";
import styles from "../../SticksForm.module.scss";
const QUANTITY_GROUP_NAME = "quantity";
const MIN_ALLOWED_QUANTITY = 1;
const QUANTITY_BY_PACKAGING_PREFERENCE_DICT = {
    single_packs: 5,
    cartons: 3,
    mix_n_match: 3,
};
export const QuantityGroup = ({ step, onChange }) => {
    const { watch, register, setValue } = useFormContext();
    const packagingPreference = watch("packagingPreference");
    const quantity = Number.parseInt(watch("quantity"));
    useEffect(() => {
        if (quantity > QUANTITY_BY_PACKAGING_PREFERENCE_DICT[packagingPreference]) {
            setValue("quantity", MIN_ALLOWED_QUANTITY.toString(), { shouldValidate: true });
        }
    }, [packagingPreference, register, quantity]);
    const registerProps = register(QUANTITY_GROUP_NAME, { onChange });
    return (_jsx(ConsumablesFormStepSection, { title: _jsx(QuantityGroupTitle, { step: step }), className: styles.stepSection, "data-testid": "quantity-selection-step", children: _jsx(QuantityRadioGroup, { registerProps: registerProps, groupName: QUANTITY_GROUP_NAME, numberOfElements: QUANTITY_BY_PACKAGING_PREFERENCE_DICT[packagingPreference], type: packagingPreference === "single_packs" ? "packs" : "cartons" }) }));
};
//# sourceMappingURL=QuantityGroup.js.map